import { api } from "@/lib/api";

export const DIFFICULTIES = [
  { v: "beginner", l: "Beginner" },
  { v: "intermediate", l: "Intermediate" },
  { v: "advanced", l: "Advanced" },
  { v: "all", l: "All levels" },
];

export const XP_RATES = { beginner: 10, intermediate: 20, advanced: 30 };

export const diffLabel = (d) => DIFFICULTIES.find((x) => x.v === d)?.l || "";

export const quizSubtitle = (a) =>
  a.kind === "personal" ? "Built from your training" : [diffLabel(a.difficulty), a.length === 5 ? "Quick 5" : null].filter(Boolean).join(" · ");

export const startGeneral = (topic, difficulty, length, revise = false) =>
  api.post("/quizzes/general/start", { topic, difficulty, length, revise }).then((r) => r.data);

export const startPersonal = () => api.post("/quizzes/personal/start").then((r) => r.data);

export const pct = (score, total) => (total ? Math.round((score / total) * 100) : 0);
